/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* eslint-disable no-unused-vars */
import React, {Component} from 'react';

/* eslint-enable no-unused-vars */
type Props = {
	history: any;
};

class LearnCompletedTutorialsPage extends Component<Props> {
	render() {
		//
		// FOR NEW DISCOVER EXPERIENCE:
		// Route all users to the new discover page.
		// Ignore any deep linking for the time being.
		//
		this.props.history.push('/cc/discover/learn');
		return null;
	}
}

export default {
	component: LearnCompletedTutorialsPage,
};
